import application from 'application/application';

import template from './keywords.template.html';

import controller from './keywords.controller';

application

	.config(['$stateProvider', $stateProvider => {

		$stateProvider

			.state('root.default.publications.keywords', {
				url: '/palavras-chave',
				views: {
					'default@root.default': {
						templateUrl: template,
						controller
					}
				}
			});

	}]);
